import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { Quill } from '../../patches/PatchedQuill';
import { supportedFormats } from '../../utils/richText';
import { applyValueToQuill, theme } from '../RichTextEditor/RichTextEditor';
import editorStyles from '../RichTextEditor/RichTextEditor.module.scss';
import styles from './RichTextViewer.module.scss';
export function RichTextViewer(props) {
    const { value = '', skin = 'standard', fitContent, weight, className, testId } = props, rest = _object_without_properties(props, [
        "value",
        "skin",
        "fitContent",
        "weight",
        "className",
        "testId"
    ]);
    const editorRef = useRef(null);
    const quillRef = useRef();
    // Initialize Quill.
    useEffect(()=>{
        if (!quillRef.current) {
            quillRef.current = new Quill(editorRef.current, {
                modules: {
                    toolbar: false
                },
                theme,
                readOnly: true,
                formats: supportedFormats
            });
        }
    }, []);
    // Update Quill's contents when value changes.
    useEffect(()=>{
        if (quillRef.current) {
            applyValueToQuill(quillRef.current, value);
        }
    }, [
        value
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(editorStyles.root, styles.viewer, styles["".concat(skin, "Skin")], weight && styles["".concat(weight, "Weight")], {
            [styles.fitContent]: fitContent
        }, className),
        "data-testid": testId,
        ref: editorRef
    }));
}
